// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-danger[data-v-5ee0b448]{margin-top:20px;width:100%}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/views/Dashboard.vue"],"names":[],"mappings":"AAEI,6BAEI,eAAA,CADA,UAAR","sourcesContent":["\n\n    .btn-danger {\n        width: 100%;\n        margin-top: 20px;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
